import React, { Component } from 'react';
import PropTypes from 'prop-types';
export default class OutsideAlerter extends Component {
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  setWrapperRef = node => {
    this.wrapperRef = node;
  };
  handleClickOutside = event => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.handleClick();
    }
  };
  render() {
    return <div ref={this.setWrapperRef}>{this.props.children}</div>;
  }
}
OutsideAlerter.propTypes = {
  children: PropTypes.element.isRequired
};
